export default __webpack_public_path__ + "static/media/image-study-board-1-w.ceb7f260.png";